import { Routes, Route } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { CategoriesPage } from '@/components/settings/CategoriesPage'
import { GroupsPage } from '@/components/settings/GroupsPage'
import { MainLayout } from '@/components/layout'
import { useAuth } from '@/contexts/AuthContext'
import { getProfile } from '@/lib/services/profiles'

export default function SettingsLayout() {
  const { user } = useAuth()
  const [profile, setProfile] = useState<any | null>(null)

  useEffect(() => {
    if (!user?.id) return
    const load = async () => {
      try {
        const p = await getProfile(user.id)
        setProfile(p)
      } catch (err) {
        console.error('Error loading profile in SettingsLayout', err)
      }
    }
    load()
  }, [user?.id])

  return (
    <MainLayout
      userName={profile?.full_name || user?.email}
      userId={user?.id}
      currentUnitId={profile?.current_unit_id || null}
    >
      <div className="p-4 lg:p-6">
        <Routes>
          <Route path="assets/categories" element={<CategoriesPage />} />
          <Route path="assets/groups" element={<GroupsPage />} />
          <Route
            path="assets"
            element={
              <div className="p-8">
                <h1 className="text-2xl font-bold">Configurações de Assets</h1>
                <p className="text-slate-600 mt-2">Selecione uma opção no menu lateral</p>
              </div>
            }
          />
          <Route
            path="/"
            element={
              <div className="p-8">
                <h1 className="text-2xl font-bold">Configurações</h1>
                <p className="text-slate-600 mt-2">Selecione uma opção no menu lateral</p>
              </div>
            }
          />
        </Routes>
      </div>
    </MainLayout>
  )
}
